<template>
    <bs5-base-modal title="Add Distributor" :visible="visible" @close="closeModal">
        <template v-slot:default>
            <form @submit.prevent="addDistributor">
                <div class="mb-3">
                    <bs5-base-label for="name">Name</bs5-base-label>
                    <bs5-base-input id="name" v-model="newDistributor.name" required />
                </div>

                <div class="mb-3">
                    <bs5-base-label for="description">Description</bs5-base-label>
                    <bs5-base-input id="description" v-model="newDistributor.description" />
                </div>
            </form>
        </template>

        <template v-slot:footer>
            <bs5-cancel-button @click="closeModal" />
            <bs5-save-button :loading="saving" @click="addDistributor" />
        </template>
    </bs5-base-modal>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import distributorService from "@/services/distributor.service";
import { Distributor } from "@/models/distributor.model";
import { showToast } from "@/utils/toast";


export default defineComponent({
    name: "AddDistributorModal",
    props: {
        visible: { type: Boolean, required: true },
    },
    emits: ["close", "distributor-added"],
    data() {
        return {
            newDistributor: ref<Distributor>({ name: "", description: "" }),
            saving: ref(false),
        };
    },
    methods: {
        async addDistributor() {
            try {
                this.saving = true;
                await distributorService.createDistributor(this.newDistributor);
                this.$emit("distributor-added");
                this.closeModal();
                showToast("Distributor added!", "success");
            } catch (error) {
                showToast("Failed to add distributor!", "error");
            } finally {
                this.saving = false;
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>